var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.3333 4.33333V3.66667C12.3333 2.73325 12.3333 2.26654 12.1517 1.91002C11.9919 1.59641 11.7369 1.34144 11.4233 1.18166C11.0668 1 10.6001 1 9.66667 1H8.33333C7.39991 1 6.9332 1 6.57668 1.18166C6.26308 1.34144 6.00811 1.59641 5.84832 1.91002C5.66667 2.26654 5.66667 2.73325 5.66667 3.66667V4.33333M7.33333 8.91667V13.0833M10.6667 8.91667V13.0833M1.5 4.33333H16.5M14.8333 4.33333V13.6667C14.8333 15.0668 14.8333 15.7669 14.5608 16.3016C14.3212 16.772 13.9387 17.1545 13.4683 17.3942C12.9335 17.6667 12.2335 17.6667 10.8333 17.6667H7.16667C5.76654 17.6667 5.06647 17.6667 4.53169 17.3942C4.06129 17.1545 3.67883 16.772 3.43915 16.3016C3.16667 15.7669 3.16667 15.0668 3.16667 13.6667V4.33333",
    stroke: "#FCAF33",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6cfb10cadd567c639c436318b529ec6f.svg";
export { ForwardRef as ReactComponent };